import { Moment } from 'moment'
import { FlatList } from 'react-native'
import styled from 'styled-components/native'
import Typography from 'APP/Converse/Typography'

export const ROW_HEIGHT = 64

export const WeeksList = styled(FlatList<Moment[]>)`
  background-color: ${({ theme }) => theme.colors.elementsBg};
`

export const WeekRowContainer = styled.View<{ isFirst: boolean; isLast: boolean }>`
  flex-direction: row;
  flex: 1 1 0%;
  padding-left: ${({ theme }) => theme.metrics.baseMargin}px;
  height: ${ROW_HEIGHT}px;
  ${({ theme, isFirst }) => isFirst && `margin-top: ${theme.metrics.baseMargin * 1.5}px;`}
  ${({ theme, isLast }) => isLast && `margin-bottom: ${theme.metrics.baseMargin * 1.5}px;`}
`

export const DaysContainer = styled.View`
  flex-direction: row;
  flex: 0.82 1 0%;
  align-items: center;
  padding-right: ${({ theme }) => theme.metrics.baseMargin}px;
  border-right-width: 1px;
  border-color: ${({ theme }) => theme.colors.elementsBorder};
`

export const DayContainer = styled.View<{ isHidden: boolean }>`
  flex: 1 1 0%;
  align-items: center;
  justify-content: center;
  aspect-ratio: 1;
  margin-vertical: ${({ theme }) => theme.metrics.baseMargin * 0.6}px;
  ${({ isHidden }) => isHidden && 'opacity: 0;'}
`

export const MonthLabel = styled(Typography)`
  flex: 1 1 0%;
  position: absolute;
  top: ${({ theme }) => -theme.fonts.fontSize.regular}px;
  text-transform: uppercase;
`

export const DayCircleContainer = styled.View<{ isActive?: boolean }>`
  flex: 1 1 0%;
  align-items: center;
  aspect-ratio: 1;
  justify-content: center;
  margin: ${({ theme }) => theme.metrics.baseMargin / 4}px;
  border-radius: 100px;
  ${({ theme, isActive }) => isActive && `background-color: ${theme.colors.success};`}
`

export const TodayMark = styled.View`
  position: absolute;
  width: 4px;
  height: 4px;
  border-radius: 2px;
  background-color: ${({ theme }) => theme.colors.text};
  bottom: ${({ theme }) => -theme.metrics.baseMargin / 4}px;
`

export const StreakContainer = styled.View`
  flex: 0.18 1 0%;
  align-items: center;
  justify-content: center;
`
